// extracted by mini-css-extract-plugin
export default {"loader_container":"Avatar_loader_container__HSqny","spinner":"Avatar_spinner__7JXoj","spin":"Avatar_spin__qojhM"};